import { Box, type SxProps, TableCell, TableSortLabel, type Theme } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { PropsWithChildren } from "react";
import { SortDirection } from "src/types/enum";

interface Props extends PropsWithChildren {
  sort: SortDirection;
  orderedByProp: boolean;
  sortHandler: React.MouseEventHandler<HTMLSpanElement> | undefined;
  sx?: SxProps<Theme>;
}

const SortableTableCell: React.FC<Props> = ({ children, sort, orderedByProp, sortHandler, sx }) => {
  return (
    <TableCell sortDirection={orderedByProp ? sort : false} sx={sx}>
      <TableSortLabel
        active={orderedByProp}
        direction={orderedByProp ? sort : SortDirection.ASC}
        onClick={sortHandler}
      >
        {children}
        {orderedByProp ? (
          <Box component="span" sx={visuallyHidden}>
            {sort === SortDirection.DESC ? "sorted descending" : "sorted ascending"}
          </Box>
        ) : null}
      </TableSortLabel>
    </TableCell>
  );
};

export default SortableTableCell;
